/**
 * Extracts the major version from a version string
 * Examples: "2024.1.2" -> "2024.1", "2023.3 EAP" -> "2023.3", "SNAPSHOT" -> "SNAPSHOT",
 * "" -> "unknown", null -> "unknown", undefined -> "unknown"
 */
export function extractMajorVersion(versionString: string | null | undefined): string {
  if (!versionString) {
    return 'unknown'
  }

  // Handle special cases like SNAPSHOT, Local, etc.
  if (!versionString.match(/^\d/)) {
    return versionString
  }

  // Extract major.minor from version strings like "2024.1.2", "2023.3 EAP"
  const versionMatch = versionString.match(/^(\d+\.\d+)/)
  if (versionMatch) {
    return versionMatch[1]
  }

  // Fallback - return the original version
  return versionString
}

/**
 * Checks if two major versions are different
 */
export function isMajorVersionDifferent(
  currentVersion: string | null | undefined,
  storedVersion: string | null | undefined,
): boolean {
  if (!currentVersion || !storedVersion) {
    return false
  }

  return extractMajorVersion(currentVersion) !== extractMajorVersion(storedVersion)
}
